"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptureBar = void 0;
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var theme_1 = require("../../components/theme");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var page_state_1 = require("../../state/page.state");
var capture_thumbnail_1 = require("../capture.thumbnail/capture.thumbnail");
var capture_bar_style_1 = require("./capture.bar.style");
(0, theme_1.addStyles)(capture_bar_style_1.Style);
exports.CaptureBar = {
    view: function (collection) {
        if (collection == null) {
            return (0, mithril_1.m)('div', { className: capture_bar_style_1.CSS.container });
        }
        var seen = {};
        // We use these three arrays here to ensure a consistent order of photos when rendering
        var ikePhotos = [];
        var tagPhotos = [];
        var otherPhotos = [];
        collection.forEachField(function (field) {
            var isIkePhoto = false;
            var photoBucket;
            if (core_shared_1.CollectionModelFieldTrueSize.isTrueSizeField(field)) {
                photoBucket = ikePhotos;
                isIkePhoto = true;
            }
            else if (core_shared_1.CollectionModelFieldImage.isImageField(field)) {
                photoBucket = tagPhotos;
            }
            else if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_DISPLAY_ALL_PHOTOS) && (core_shared_1.CollectionModelFieldHeight.isHeightField(field) ||
                core_shared_1.CollectionModelFieldAnchor.isAnchorField(field) ||
                core_shared_1.CollectionModelFieldNumber.isNumberField(field) ||
                core_shared_1.CollectionModelFieldLocation.isLocationField(field) ||
                core_shared_1.CollectionModelFieldVector.isVectorField(field))) {
                photoBucket = otherPhotos;
            }
            else {
                return;
            }
            var captures = field.getOwnedCaptures() || [];
            captures.sort(function (a, b) {
                if (a.collectedAt.iso < b.collectedAt.iso) {
                    return 1;
                }
                if (a.collectedAt.iso > b.collectedAt.iso) {
                    return -1;
                }
                return 0;
            });
            var _loop_1 = function (capture) {
                if (!seen[capture.objectId]) {
                    var title = "".concat(field.schema.displayName, " - ").concat(services_1.Services.DateTime.formatDateTime(capture.collectedAt.iso));
                    seen[capture.objectId] = true;
                    var thumbnail = capture_thumbnail_1.CaptureThumbnail.view(collection, capture, {
                        truesize: capture.type === core_api_1.IkeCaptureType.TRUE_SIZE,
                        title: title,
                        selected: page_state_1.CurrentState.inspectedCaptureId === capture.objectId,
                        action: function () { return page_state_1.CurrentState.setInspectedCollection(page_state_1.CurrentState.inspectedCollectionRevision, capture.objectId); },
                        icon: isIkePhoto,
                        size: capture_bar_style_1.THUMBNAIL_SIZE
                    });
                    photoBucket.push(thumbnail);
                }
            };
            for (var _i = 0, captures_1 = captures; _i < captures_1.length; _i++) {
                var capture = captures_1[_i];
                _loop_1(capture);
            }
        });
        return (0, mithril_1.m)('div', { className: capture_bar_style_1.CSS.container }, ikePhotos.concat(tagPhotos, otherPhotos));
    }
};
//# sourceMappingURL=capture.bar.js.map